import { gettext } from '@eventbrite/i18n';
import loadable from '@loadable/component';
import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { DiscoverState, PointOfInterestShelfState } from '../../../../types';

import './PointOfInterestShelfContainer.scss';

const PointOfInterestShelf = loadable(
    () => import('../../../../components/ThingsToDoShelf'),
    {
        resolveComponent: (component: { ThingsToDoShelf: React.ReactNode }) =>
            component.ThingsToDoShelf,
    },
);

export const PointOfInterestShelfSection: React.FunctionComponent<
    PointOfInterestShelfState
> = ({ location, tags }) => {
    const shelfHeader = {
        title: gettext('Points of Interest near %(geo)s', {
            geo: location,
        }),
        url: undefined,
    };

    const showPointOfInterestShelf = tags.length > 0;

    let shelfTags;
    if (showPointOfInterestShelf) {
        shelfTags = tags.map((tag) => ({
            displayText: tag.pointOfInterestName,
            linkUrl: tag.linkUrl,
        }));
    }

    return (
        <>
            {showPointOfInterestShelf && (
                <PointOfInterestShelf
                    tags={shelfTags}
                    header={shelfHeader}
                    shelfClassName="city-browse-poi-shelf"
                    tagsConfig={{
                        backgroundColor: 'white',
                        tagColor: '#F8F7FA',
                    }}
                    shelfBackgroundColor="white"
                />
            )}
        </>
    );
};

export const _mapStateToProps = (state: DiscoverState) => {
    return {
        tags: state.pointOfInterestShelf.tags,
        location: state.pointOfInterestShelf.location,
    };
};

export const PointOfInterestShelfContainer: FunctionComponent = connect(
    _mapStateToProps,
)(PointOfInterestShelfSection);
